<template>
  <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7'}" id="outermost">
    <van-nav-bar
      title="问题跟踪"
      left-text="返回"
      left-arrow
      @click-left="$router.back()"
      id="topbar"
    />
    <div style="padding:10px 20px 20px 20px">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :immediate-check="false"
      >
        <van-search
          v-model="problemName"
          placeholder="请输入问题名称"
          @search="onSearch"
          shape="round"
          background="#F7F7F7"
        />
        <div v-for="(item,index) in problemList" :key="index" style="background-color:#FFFFFF;">
          <div class="problem">
            <div style="padding:0px 20px;border-bottom:1px solid #EBEEF5;">
              <div class="typeTxt">
                <span></span>
                {{ item.problemSubclass }}
              </div>

              <van-row class="infoRow" align="center">
<!--                <van-col>问题类型{{ item.id }}：</van-col>-->
                <van-col>问题类型：</van-col>
                <van-col>{{ item.problemTypeName }}</van-col>
              </van-row>

              <van-row class="infoRow" align="center">
                <van-col>问题状态：</van-col>
                <van-col>{{ getStateLabel(item.rectificationStatus) }}</van-col>
              </van-row>

              <van-row class="infoRow">
<!--                <van-col span="24" style="line-height:30px;">问题子类：</van-col>-->
                <van-col>问题子类：</van-col>
<!--                <van-col style="line-height:20px;">{{ item.problemSubclass }}</van-col>-->
                <van-col>{{ item.problemSubclass }}</van-col>
              </van-row>

              <van-row class="infoRow" align="center">
                <van-col>问题等级：</van-col>
                <van-col>{{ item.levelName }}</van-col>
              </van-row>

              <van-row v-if="item.problemDescription" class="infoRow">
<!--                <van-col span="24" style="line-height:30px;">问题描述：</van-col>-->
                <van-col>问题描述：</van-col>
<!--                <van-col style="line-height:20px;">{{ item.problemDescription }}</van-col>-->
                <van-col>{{ item.problemDescription }}</van-col>
              </van-row>
              <van-row v-else class="infoRow" align="center">
                <van-col>问题描述：</van-col>
                <van-col>无</van-col>
              </van-row>

              <van-row class="infoRow" align="center">
                <van-col>检查日期：</van-col>
                <van-col>{{ item.inspectionDate }}</van-col>
              </van-row>

              <van-row class="infoRow" align="center">
                <van-col>整改期限：</van-col>
                <van-col>{{ item.rectificationPeriod }}</van-col>
              </van-row>

              <van-row v-if="item.problemPhotos" class="infoRow">
                <van-col span="24" style="line-height:30px;">现场照片：</van-col>
                <van-image v-for="(p, i) of item.problemPhotos.split(',')" :key="i" :src="apiUrl + 'download/' + p"
                           width="60" height="60" @click="showSignPhoto(p)" style="margin-right: 10px"/>
              </van-row>
              <van-row v-else class="infoRow" align="center">
                <van-col>现场照片：</van-col>
                <van-col>无</van-col>
              </van-row>

            </div>
            <van-row type="flex" justify="space-between" class="btnDiv">
              <van-col span="12">
                <van-button color="#1B75F6" @click="toFollowRecords(item.id)">问题跟踪记录</van-button>
              </van-col>
              <van-col span="10" v-if="item.rectificationStatus === '0'">
                <van-button color="#1B75F6" style="width: 90px;margin-left: 8px"
                            @click="extend(item.id,item.rectificationPeriod,index)">延长日期
                </van-button>
              </van-col>

              <van-col span="10" style="margin-left: 10px">
                <van-button color="#1B75F6" :disabled="item.rectificationStatus !== '3'" @click="toCompleteProblem(item,index)">整改审批</van-button>
              </van-col>
<!--              <van-col span="10" v-else-if="item.rectificationStatus === '1'" style="margin-left: 10px">-->
<!--                <van-button color="#1B75F6" style="opacity: 0.43;" @click="toCompleteProblem2(item)">已整改</van-button>-->
<!--              </van-col>-->
            </van-row>
          </div>
        </div>
      </van-list>

      <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
        <van-datetime-picker v-model="rectificationPeriod" type="date" @change="changeFn()" @confirm="confirmFn()"
                             @cancel="cancelFn()"/>
      </van-popup>
    </div>

  </div>
</template>
<script>
import $ from '@/fly'
import Setting from '@/setting';
import Vue from 'vue';
import {ImagePreview} from 'vant';

Vue.use(ImagePreview);
export default {
  name: 'project-problemFollowCheckTask',
  data() {
    return {
      show: false,
      rectificationPeriod: new Date(),
      changeDate: new Date(),
      clientHeight: window.screen.height,
      problemList: [],
      changeProblem: {},
      loading: false,
      finished: false,
      apiUrl: Setting.apiBaseURL,
      problemName: ''
    }
  },
  computed: {},
  methods: {
    getStateLabel(state){
      if (state === '0') {
        return "未整改"
      } else if (state === '1') {
        return "已通过"
      } else if (state === '2') {
        return "已退回"
      } else if (state === '3') {
        return "待审批"
      } else {
        return "未知"
      }
    },
    showSignPhoto(id) {
      ImagePreview({
        images: [
          Setting.apiBaseURL + 'download/' + id
        ],
        closeable: true
      });
    },
    onSearch() {
      this.getList();
    },
    getList() {
      var that = this;
      $.get('problem/getByProjectCompany', {
        projectId: localStorage.getItem('projectId'),
        companyId: localStorage.getItem('companyId'),
        problemSubclass: that.problemName
      }).then(res => {
        that.problemList = res;
        // 加载状态结束
        that.loading = false;
        that.finished = true;
      })
    },
    toFollowRecords(id) {
      localStorage.setItem('problemId', id);
      this.$router.push({name: 'project-problemFollowRecords'});
    },
    extend(id, defaultDate,index) {
      this.changeProblem = {
        id: id,
        rectificationPeriod: new Date(defaultDate),
        index: index
      }
      this.rectificationPeriod = new Date(defaultDate)
      this.show = true
      return false;
    },
    changeFn() {
      this.problemList[this.changeProblem.index].rectificationPeriod = this.timeFormat(this.changeProblem.rectificationPeriod);
    },
    confirmFn() {
      this.show = false;
      let chageTime = this.timeFormat(this.rectificationPeriod)
      this.problemList[this.changeProblem.index].rectificationPeriod = this.timeFormat(this.rectificationPeriod);
      $.post('problem/modifyRectificationPeriod', {id: this.changeProblem.id, rectificationPeriod: chageTime})
    },
    cancelFn() {
      this.show = false;
    },
    toCompleteProblem(item,index) {
      this.$router.push({name: 'project-completeProblem', params: {problem: item,num:index}});
    },
    toCompleteProblem2(item) {
      this.$router.push({name: 'project-completeProblemInfo', params: {problem: item}});
    },
    timeFormat(time) { // 时间格式化 2019-09-08
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      return year + '-' + month + '-' + day
    }
  },
  mounted() {
    let problemCheckTaskList = JSON.parse(localStorage.getItem('checkTaskProblemList'))
    // console.log(problemCheckTaskList)
    this.problemList = problemCheckTaskList
    this.finished = true;
  }
}

</script>

<style lang="less" scoped>
.van-search__content {
  border: 1px solid #8da0eb;
}

.problem {
  margin-bottom: 20px;
}

.typeTxt {
  font-size: 30px;
  font-weight: bold;
  border-bottom: 1px solid #EBEEF5;
  padding: 25px 0px 15px 0px;
  letter-spacing: 1px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.typeTxt span {
  width: 5px;
  background-color: #50C9FF;
  display: inline-block;
  height: 34px;
  vertical-align: middle;
}

.infoRow {
  padding: 20px 5px;
  font-size: 26px;
  font-weight: bold;
}

.infoRow .van-col:nth-child(1) {
  color: #999999;
}

.btnDiv {
  padding: 40px;
}

.btnDiv button {
  width: 100%;
  height: 60px;
  line-height: 60px;
  border-radius: 5px;
}
</style>
